import { render } from "./videoSmallBox.vue?vue&type=template&id=78bf7dd6&scoped=true"
import script from "./videoSmallBox.vue?vue&type=script&lang=js"
export * from "./videoSmallBox.vue?vue&type=script&lang=js"

import "./videoSmallBox.vue?vue&type=style&index=0&id=78bf7dd6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-78bf7dd6"

export default script